<template>
  <div id='' class='gPageBorder' v-loading='loading'>

    <bdialog :config='bconfig'></bdialog>

    <div id=''>
      <div style=''>

        <el-row>
          <el-col :span="20" class=''>
            <div class='gSgLeftBtn' >
              <el-button v-show='userType == 0'  type='primary' @click='addBlt'>{{$t('app_addblt')}}</el-button>
            </div>
          </el-col>

          

          <!-- <el-col :span="4">
            <div class='gCtrl'>
              
              <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
            </div>
          </el-col> -->
            

          <el-col :span="4">
            <div class='gSideCtrl'>
              <el-input  :placeholder="$t('app_name')" v-model='queryKey' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>

        </el-row>
        
        
      </div>
    </div>


    <!-- <div id='adFilter' v-show=0>
      <label>{{$t('app_filter')}}:</label>
      <el-select style='width:16%;margin-left:20px;' v-model="appTypeValue" clearable :placeholder="$t('app_type')">
        <el-option
          v-for="item in appTypes"
          :key="item.appClassifyId"
          :label="item.appClassifyName"
          :value="item.appClassifyId">
        </el-option>
      </el-select>
      <el-select style='width:16%;margin-left:20px;' v-model="appStatusValue" clearable :placeholder="$t('app_status')">
        <el-option
          v-for="item in appStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div> -->

    <div id=''>
      <el-table
        @row-click='cellClick'
        :data="tableData"
        border
        @sort-change="sortChange"
        class='tbPoint gTopMg'
        style="width: 100%;border:none;">
        
        <el-table-column
          header-align='center'
          align='center'
          prop="noticeName"
          :label="$t('app_blttt')"
          width="">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='center'
          prop="times"
          width='140'
          :label="$t('app_readnum')">
        </el-table-column>


        <el-table-column
          header-align='center'
          align='center'
          prop="addTime"
          width='176'
          :label="$t('app_addtime')">
        </el-table-column>
      
        
        <el-table-column
          header-align='center'
          align='center'
          prop="operate"
          width='86'
          :label="$t('app_operate')">
          <template slot-scope='scope'>

            <span style='background:none;'>

           

            
            <el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
              <el-button v-show='userType == 0' type=text @click='editBlt(scope.row)'><i class="fa fa-pencil" style=""></i></el-button>
            </el-tooltip>

           

           
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top" v-show='userType == 0'>
              <el-button type='text' @click='delBlt(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>
            
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>
        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<style>
  /* html,body{width:100%;height:100%;}*/

  .tbPoint td{cursor:pointer}

  .cmMarginFrame{width:calc(100% - 20px);height:100%;background:none;margin-left:10px;}

  #appDepot{min-width:840px;}

  #adData{}

  
    
</style>

<script>
  // import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import mm from 'moment'
  import bdialog from './bdialog'
  export default{
    components: {
      bdialog
    },
    data () {
      var that = this
      return {
        userType: this.$getWObj().login.userType,
        bconfig: '',
        orderName: '',
        orderType: '',
        // mechanismData: {
        //   callback (value) {
        //     that.mech = value
        //     that.selectChange(value)
        //   }
        // },
        total: 0,
        index: 1,
        dvTotal: 0,
        loading: 0,
        appType: '',
        queryKey: ''
      }
    },
    computed: {
    
     
    },
    methods: {
      sortChange (vl) {
        switch (vl.prop) {
          case 'createTime':
            this.orderName = '2'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getList()
      },
      bindOperate (row) {
        //console.log(row)
        
        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$bindApp('0', row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {
          // console.log(localStorage.mechanismId, tNo)
          this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        }
      },
      
      editBlt (row) {
        var _this = this
        this.bconfig = {
          type: 1,
          edit: 1,
          id: row.id,
          vinfo: '',
          binfo: '',
          callback: () => {
            _this.getList()
          }
        }
      },
      query () {
        this.getList()
      },
      selectChange (vl) {
        this.selectMid = vl
        this.getList()
      },
      reset () {
        this.queryKey = ''
        this.appType = ''
        this.getList()
      },
      pageSelect (index) {
        this.index = index
        this.getList()
      },
      pageDvSelect (index) {
        this.dvIndex = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      delBlt (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.$delBulletin(obj.id, res => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      submitApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$verifyFst(obj.recordId, '', '1', (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
          
        }, '')
      },
      cellClick (row, ev, col) {
        if (col.label && col.label === this.$t('app_operate')) {
          return
        }

        
        this.bconfig = {
          type: 2,
          edit: false,
          vinfo: '',
          binfo: {
            title: row.noticeName,
            content: row.noticeInfo
          },
          callback: () => {
            // _this.getList()
          }
        }

      },
      addBlt () {
        var _this = this
        this.bconfig = {
          type: 1,
          edit: false,
          vinfo: '',
          binfo: '',
          callback: () => {
            _this.getList()
          }
        }
      },
      getList () {
        this.loading = 1
        // var dsid = this.selectMid ? this.selectMid : '' //渠道商id
        var name = this.queryKey ? this.queryKey : ''

        this.$bulletin(this.index, this.$gRow, name, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    mounted () {
      
      this.getList()
    },
    destroyed () {
    }
  }
</script>



// WEBPACK FOOTER //
// blist.vue?5127ccb1